import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CartService } from '../../api';
import { CartItem } from '../model/cart-item-model';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-view-cart',
  templateUrl: './view-cart.component.html',
  styleUrls: ['./view-cart.component.css']
})
export class ViewCartComponent implements OnInit {
  products:Array<CartItem>;
  cartTotal:number = 0;
  public onlineOffline: boolean = navigator.onLine;
  ismobile:any = false;
  @BlockUI() blockUI: NgBlockUI;

  constructor(private cartService: CartService, changeDetectorRef: ChangeDetectorRef) {
    this.blockUI.start('Loading, please wait...');
    window.addEventListener('online', () => {this.onlineOffline = true;});
    window.addEventListener('offline', () => {this.onlineOffline = false});
    if(this.onlineOffline) {
      cartService.cart$.subscribe(updatedCart => {
        this.products = updatedCart;
        this.blockUI.stop();
      });
    }
  }

  ngOnInit() {
    if(screen.width < 769){
      this.ismobile = true;
    }
    if(this.onlineOffline) {
      this.cartService.getCart();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/cart/view-cart/view-cart.component.ts